// app/javascript/controllers/quiz_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startButton"]

  // connect() {
  //   this.updateButtonHref();
  // }

  updateButtonHref(event) {
    // Allow both click and keyboard activation (Enter/Space)
    if (event.type === 'keydown' && !(event.key === ' ' || event.key === 'Enter')) return;
    event.preventDefault();

    const checked = this.element.querySelector('input[name="mode"]:checked');
    if (checked) {
      const mode = checked.value;
      // Build URL
      const quizId = document.getElementById("start-button").getAttribute("data-quiz-id") || '';
      const firstIndex = document.getElementById("start-button").getAttribute("data-first-index") || '';
      const url = `/quiz_item_responses/${firstIndex}?mode=${mode}&quiz_id=${quizId}&apply_mode=1`;
      window.location.href = url;
    } else {
      document.getElementById('modeMsg').innerText = "Please select one mode to continue"
    }
  }

  connect() {
    // Add keyboard accessibility for start button
    const btn = document.getElementById('start-button');
    if (btn) {
      btn.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          this.updateButtonHref(e);
        }
      });
      // Set data attributes for URL building
      btn.setAttribute('data-quiz-id', btn.getAttribute('data-quiz-id') || (window.quizId || ''));
      btn.setAttribute('data-first-index', btn.getAttribute('data-first-index') || (window.firstNotAnsweredIndex || ''));
    }
  }
}
